import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getHelpCenterConfig = (rootState) => {
  if (!getIsB2C(rootState)) {
    return {};
  }

  return get(rootState, 'config.common.ws-helpcenter', {});
};

export default getHelpCenterConfig;
